import React, { Component, useEffect, useState } from 'react';
import { translate } from '../Services/translation';
import { useDispatch } from 'react-redux';
import { load as loadCart } from '../Actions/Cart.action';

const StringBuilder = (props) => {
    const dispatch = useDispatch();
    const [cart, setcart] = useState([]);
    const [collapsed, setcollapsed] = useState(true);
    const [showStringImage, setshowStringImage] = useState(false);
    const [url, seturl] = useState("");
    const [collapsible, setcollapsible] = useState(false);
    const [textColor, settextColor] = useState("");
                                            
    
    useEffect(() => {
        if (props) {
            setshowStringImage(props.stringImageHtml !== "");
            seturl(`https://build-your-own.stringfurniture.com/?system=1&lan=1&countrycode=SE&token=&guid=${props.guid}`);
            setcollapsible((props.collapsible === undefined || props.collapsible.toLowerCase() !== "false"));
            setcollapsed((props.collapsible === undefined || props.collapsible.toLowerCase() !== "false"));
            settextColor(props.textColor);
        }
    }, [props]);

    const messageHandler = (event) => {
        if (event.data.event == "byoLoaded") {
            handleLoad(event)
        }
        if (event.data.event == "cartUpdate") {
            addToCart(event)
        }
        if (event.data.event == "designUpdate") {
            handleCart(event)
        }
    }

    addEventListener('message', messageHandler, true);

    const handleLoad = (event) => {
        // enable the button in BYO
        document.querySelector('iframe').contentWindow.postMessage({/*event:"enableCart",*/data: {} }, "*")
    }

    const addToCart = (event) => {
        buy(event.data.data.items);
    }

    const handleCart = (event) => {
        let designid = event.data.data.designid;
        let designname = event.data.data.name;
        let items = event.data.data.items;

        var stringArrayItem = {
            designid: designid,
            name: designname,
            items: items.map(x => {
                return {
                    article: x.article,
                    ean: x.ean,
                    quantity: x.quantity,
                    length: x.length
                }
            })
        };
        setcart(stringArrayItem);        
    }

    const buy = () => {
        // Add to cart
        fetch("/api/cart/addstringbuilder", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            body: JSON.stringify(
                cart
            ),
            redirect: 'follow'
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    return response.text().then(function (text) {
                        throw new Error(text);
                    });
                }
            })
            .then(result => {
                dispatch(loadCart(result));
            })
            .catch(error => console.log(error));
    }

    const toggle = () => {
        if (collapsible) {
            setcollapsed(!collapsed);            
        }
    }
    
        return (<div className={'string-builder' + (collapsed ? ' string-builder--collapsed' : '')}>
            <div className={'string-builder__img' + (showStringImage ? '' : ' do-not-show-image')} dangerouslySetInnerHTML={{ __html: props.stringImageHtml }}></div>
            {collapsible && collapsed ? <div className={'string-builder__header' + (showStringImage && collapsed ? ' show-image' : '') + (collapsible ? ' collapsable' : '')} onClick={() => { toggle() }}>
                <h2 className="main-image__title">
                    {translate('stringbuilder.header')}
                </h2>
                <svg>
                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use>
                </svg>
            </div> : <div className={'string-builder__header' + (collapsible ? ' collapsable' : '')} onClick={() => { toggle() }}>
                {translate('stringbuilder.header')}
                {collapsible ? <svg >
                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use>
                </svg> : null}
            </div>
            }
            <div className="string-builder__content">
                <iframe src={url} scrolling="no"></iframe>
                <div className="string-builder__controls">
                    <a className="ti-btn" onClick={() => { buy() }}>{translate('stringbuilder.add')}</a>
                </div>
            </div>
        </div>);    
}

export default StringBuilder;
